import React from 'react'
import _ from 'lodash'

import {Cell} from 'fixed-data-table'

import {Icon} from 'antd'

export const SortTypes = {
   ASC:     'ASC',
   DESC:    'DESC',
   DEFAULT: 'DESC'
}

export const reverseSort = sortDir => (SortTypes.ASC === sortDir ? SortTypes.DESC : SortTypes.ASC)

const SortableHeaderCell = ({
   sortDir,
   columnKey,
   onToggleColumn,
   onSortChange,
   children,
   ...props
}) => (
   <Cell {...props}>
      <a
         onClick={() => onSortChange(columnKey, sortDir ? reverseSort(sortDir) : SortTypes.DEFAULT)}
      >
         {children} {sortDir && (sortDir === SortTypes.DESC ? '↓' : '↑')}
      </a>

      <a className="pull-right" onClick={() => onToggleColumn(columnKey)}>
         <Icon type="close" />
      </a>
   </Cell>
)

SortableHeaderCell.propTypes = {
   sortDir:        React.PropTypes.oneOf(_.values(SortTypes)),
   columnKey:      React.PropTypes.string.isRequired,
   onToggleColumn: React.PropTypes.func.isRequired,
   onSortChange:   React.PropTypes.func.isRequired,
   children:       React.PropTypes.node.isRequired
}

export default SortableHeaderCell



// WEBPACK FOOTER //
// lib/ui/table/SortableHeaderCell.jsx